// extracted by mini-css-extract-plugin
export default {"container":"GroupsCellRenderer_container__3MxMe","tag":"GroupsCellRenderer_tag__T+cbT"};